import { render } from "./BatchClassList.vue?vue&type=template&id=03e46e0a&scoped=true&ts=true"
import script from "./BatchClassList.vue?vue&type=script&lang=ts"
export * from "./BatchClassList.vue?vue&type=script&lang=ts"

import "./BatchClassList.vue?vue&type=style&index=0&id=03e46e0a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03e46e0a"]])

export default __exports__